import React from 'react';
import styles from './IdqsOrderFilter.module.scss';
import { FaAngleDoubleDown, FaAngleDoubleUp } from 'react-icons/fa';
import withRouter from '../../util/customWithRouter';
import { Button } from '../../components/Button';
import { Label } from '../../components/Label';
import moment from 'moment';
import businessMoment from 'moment-business';
import Tooltip from 'devextreme-react/tooltip';
import PropTypes from 'prop-types';
import { CheckBox, TextBox, NumberBox, SelectBox, DateBox, TagBox } from 'devextreme-react';
import List from 'devextreme-react/list';
import { isEmpty } from '../../util/functions';
import { datePattern, timePattern } from '../../util/constants';
import { idqsCategoryTypes, sideTypes, orderStatusTypes, capacityTypes, filterDatePattern, filterTimePattern } from '../../util/orderFilterConstants';
import { format } from '../../util/locale';

const disableAutoComplete = {
  autocomplete: 'off'
};

const formatDate = date => {
  return format(date, date, 'date');
};

const formatTime = time => {
  return format(time, time, 'time');
};

const newDate = new Date();

const initialState = {
  symbol: '',
  startDate: newDate,
  endDate: newDate,
  startTime: null, // update time
  endTime: null, // update time
  orderEnterStartTime: null,
  orderEnterEndTime: null,
  mpid: '',
  side: null,
  linkAtsId: '',
  orderCapacity: null,
  clientOrderId: '',
  orderStatus: ['Open', 'Rejected', 'Canceled', 'Filled', 'Expired'],
  orderId: '',
  minPrice: null,
  maxPrice: null,
  minSize: null,
  maxSize: null,
  category: [7167, 6209, 7094, 7168, 1001, 8]
};

class IdqsOrderFilter extends React.Component {
  constructor (props) {
    super(props);
    const localStorageSearch = window.localStorage.getItem('recentIdqsOrderSearch');
    const recentSearches = localStorageSearch && JSON.parse(localStorageSearch);
    this.state = {
      ...initialState,
      errorMessages: [],
      collapseOnSearch: window.localStorage.getItem('tps_collapseSearch') === 'true',
      showFilter: true,
      isSymbolFocus: false,
      isMpidFocus: false,
      recentSymbolSearch: recentSearches && recentSearches.symbol,
      recentMpidSearch: recentSearches && recentSearches.mpid

    };

    // preserve the initial state in a new object
    this.baseState = this.state;
    this.getOrderDataFilter = this.getOrderDataFilter.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleDownload = this.handleDownload.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleRecentSearches = this.handleRecentSearches.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  componentDidMount () {
    const params = new URLSearchParams(this.props.router.location.search);
    const mpid = params.get('mpid') || '';
    const symbol = params.get('symbol') || '';
    const orderId = params.get('orderId') || '';
    if (mpid || symbol || orderId) {
      this.setState({
        mpid: mpid,
        symbol: symbol,
        orderId: orderId
      });
    }
  }

  componentDidUpdate (prevProps) {
    if (!isEmpty(this.props.startDateUpdate) && prevProps.startDateUpdate !== this.props.startDateUpdate) {
      var startDateUpdateValue = moment(this.props.startDateUpdate, 'YYYY-MM-DD').toDate();
      startDateUpdateValue.setHours(0, 0, 0, 0);
      this.setState({
        startDate: startDateUpdateValue
      });
    }
    if (!isEmpty(this.props.endDateUpdate) && prevProps.endDateUpdate !== this.props.endDateUpdate) {
      var endDateUpdateValue = moment(this.props.endDateUpdate, 'YYYY-MM-DD').toDate();
      endDateUpdateValue.setHours(23, 59, 0, 0);
      this.setState({
        endDate: endDateUpdateValue
      });
    }

    if (prevProps.mpidUpdate !== this.props.mpidUpdate && this.props.mpidUpdate) {
      this.setState({
        mpid: this.props.mpidUpdate
      });
    }

    if (prevProps.symbolUpdate !== this.props.symbolUpdate && this.props.symbolUpdate) {
      this.setState({
        symbol: this.props.symbolUpdate
      });
    }

    if (prevProps.orderIdUpdate !== this.props.orderIdUpdate && this.props.orderIdUpdate) {
      this.setState({
        orderId: this.props.orderIdUpdate
      });
    }

    if (prevProps.clientOrderIdUpdate !== this.props.clientOrderIdUpdate && this.props.clientOrderIdUpdate) {
      this.setState({
        clientOrderId: this.props.clientOrderIdUpdate
      });
    }

    if (prevProps.minPriceUpdate !== this.props.minPriceUpdate && this.props.minPriceUpdate) {
      this.setState({
        minPrice: this.props.minPriceUpdate
      });
    }

    if (prevProps.maxPriceUpdate !== this.props.maxPriceUpdate && this.props.maxPriceUpdate) {
      this.setState({
        maxPrice: this.props.maxPriceUpdate
      });
    }

    if (prevProps.startTimeUpdate !== this.props.startTimeUpdate && this.props.startTimeUpdate) {
      var startTimeUpdateValue = moment(this.props.startTimeUpdate, timePattern).toDate();
      this.setState({
        startTime: startTimeUpdateValue
      });
    }

    if (prevProps.endTimeUpdate !== this.props.endTimeUpdate && this.props.endTimeUpdate) {
      var endTimeUpdateValue = moment(this.props.endTimeUpdate, timePattern).toDate();
      this.setState({
        endTime: endTimeUpdateValue
      });
    }

    if (prevProps.isDataLoaded !== this.props.isDataLoaded) {
      if (this.props.isDataLoaded && this.state.collapseOnSearch) {
        this.setState({ showFilter: false });
      }
    }
  }

  toggleFilter = () => this.setState(state => ({ showFilter: !state.showFilter }));

  handleListItemClick = (e, name) => {
    this.setState({
      isSymbolFocus: false,
      isMpidFocus: false,
      [name]: e.itemData
    });
  }

  showToolTip = label => {
    this.setState({
      [label]: true
    });
  }

  hideToolTip = label => {
    this.setState({
      [label]: false
    });
  }

  handleCopyValue = (param, value) => {
    this.setState({ [param]: this.state[value] });
  }

  handleChange (event, name) {
    // console.log(event.value);
    //  console.log(name);
    let val = event.value;
    if (val && typeof (val) === 'string') {
      // val = val.replace(/[^a-zA-Z0-9]/g, '');
      val = val.replace(/[^\x20-\x7E]/g, '');
    }
    this.setState({
      [name]: val
    });
  }

  handleSearch () {
    this.handleSubmit('search');
  }

  handleDownload () {
    this.handleSubmit('download');
  }

  handleSubmit (type) {
    let queryParam = this.state;
    //  console.log(queryParam);
    var errorMessages = [];
    if (!('startDate' in queryParam) || queryParam['startDate'] === null) {
      errorMessages.push('Please select start date');
    }
    if (!('endDate' in queryParam) || queryParam['endDate'] === null) {
      errorMessages.push('Please select end date');
    }
    if (queryParam['endDate'] !== null && queryParam['startDate'] !== null) {
      if (queryParam['startDate'] > queryParam['endDate']) {
        errorMessages.push('Start date can not be greater than end date');
      } else {
        const fromDate = moment(queryParam['startDate']);
        const toDate = moment(queryParam['endDate']);
        const businessDaysDiff = businessMoment.weekDays(fromDate, toDate);
        // 5 business days logic
        if (businessDaysDiff > 4) {
          errorMessages.push('Date range must be within 5 business days. Please adjust your date range');
        }
      }
    }
    if (isEmpty(queryParam['symbol']) && isEmpty(queryParam['mpid']) && isEmpty(queryParam['clientOrderId']) &&
    isEmpty(queryParam['linkAtsId']) && isEmpty(queryParam['orderId'])) {
      errorMessages.push('Please select MPID or Symbol or ClientOrderId or OrderId or LinkAtsId');
    }
    if (queryParam['minSize'] && queryParam['maxSize'] && queryParam['maxSize'] < queryParam['minSize']) {
      errorMessages.push('Min Order size can not be greater than max order size');
    }
    if (queryParam['minPrice'] && queryParam['maxPrice'] && queryParam['maxPrice'] < queryParam['minPrice']) {
      errorMessages.push('Min Order price can not be greater than max order price');
    }
    this.setState({ errorMessages: errorMessages });
    if (errorMessages.length === 0) {
      // put recent searches in the localstorage
      this.handleRecentSearches(queryParam);
      // try to get data
      let params = this.getOrderDataFilter(queryParam);
      this.props.search(params, type);
    }
  }

  handleRecentSearches (params) {
    const recentSearchStorage = window.localStorage.getItem('recentIdqsOrderSearch');

    let recentSearchData = {
      symbol: [],
      mpid: []
    };

    if (recentSearchStorage) {
      recentSearchData.symbol = JSON.parse(recentSearchStorage).symbol;
      recentSearchData.mpid = JSON.parse(recentSearchStorage).mpid;
    }
    const symbolField = params.symbol && params.symbol.toUpperCase();
    const mpidField = params.mpid && params.mpid.toUpperCase();
    if (symbolField && symbolField !== '') {
      if (!recentSearchData.symbol.includes(symbolField))recentSearchData.symbol.unshift(symbolField);

      if (recentSearchData.symbol.includes(symbolField)) {
        const symbolArray = recentSearchData.symbol;
        const index = symbolArray.indexOf(symbolField);
        symbolArray.splice(index, 1);
        symbolArray.unshift(symbolField);
      }
    }
    if (mpidField && mpidField !== '') {
      if (!recentSearchData.mpid.includes(mpidField))recentSearchData.mpid.unshift(mpidField);

      if (recentSearchData.mpid.includes(mpidField)) {
        const mpidArray = recentSearchData.mpid;
        const index = mpidArray.indexOf(mpidField);
        mpidArray.splice(index, 1);
        mpidArray.unshift(mpidField);
      }
    }

    if (recentSearchData.symbol.length > 10) recentSearchData.symbol.pop();

    if (recentSearchData.mpid.length > 10) recentSearchData.mpid.pop();

    window.localStorage.setItem('recentIdqsOrderSearch', JSON.stringify(recentSearchData));

    this.setState({
      isMpidFocus: false,
      isSymbolFocus: false,
      recentSymbolSearch: recentSearchData.symbol,
      recentMpidSearch: recentSearchData.mpid
    });
  }

  renderErrorMessages () {
    const errorMessages = this.state.errorMessages;
    return errorMessages.map((errorMessage, i) => <div key={`Error-${i}`}>{errorMessage}</div>);
  }

  getOrderDataFilter (queryParam) {
    var params = [];

    Object.keys(queryParam).forEach((key) => {
      let val = queryParam[key];
      if (val !== null) {
        if (key.toLowerCase().includes('date') && moment.isDate(val)) {
          params[key] = moment(val).format(datePattern);
        } else if (key.toLowerCase().includes('time') && moment.isDate(val)) {
          params[key] = moment(val).format(timePattern);
        } else if (typeof val === 'string') {
          if (val.trim() !== '') {
            params[key] = val;
          }
        } else {
          params[key] = val;
        }
      }
    });

    return params;
  }

  handleFocusIn (field) {
    this.setState({ [field]: true });
  }
  handleFocusOut (field) {
    setTimeout(() => { this.setState({ [field]: false }); }, 250);
  }

  handleCollapseOption = () => {
    this.setState(state => ({ collapseOnSearch: !state.collapseOnSearch }), () => window.localStorage.setItem('tps_collapseSearch', this.state.collapseOnSearch));
  }

  renderCollapseDate = () => {
    const state = this.state;
    const isSameDate = state.startDate === state.endDate;

    return `${isSameDate ? formatDate(state.startDate) : formatDate(state.startDate) + '-' + formatDate(state.endDate)}`;
  }

  renderUpdateTime = () => {
    const state = this.state;
    const isfromTime = state.startTime;
    const istoTime = state.endTime;
    const isSameTime = isfromTime === istoTime;
    let time = '';

    if (isfromTime && istoTime) time = `${formatTime(isfromTime)}-${formatTime(istoTime)}`;
    if (isfromTime && !istoTime) time = `From ${formatTime(isfromTime)}`;
    if (!isfromTime && istoTime) time = `To ${formatTime(istoTime)}`;

    return `${isSameTime ? formatDate(state.startTime) : time}`;
  }

  renderEnteredTime = () => {
    const state = this.state;
    const isfromTime = state.orderEnterStartTime;
    const istoTime = state.orderEnterEndTime;
    const isSameTime = isfromTime === istoTime;
    let time = '';

    if (isfromTime && istoTime) time = `${formatTime(isfromTime)}-${formatTime(istoTime)}`;
    if (isfromTime && !istoTime) time = `From ${formatTime(isfromTime)}`;
    if (!isfromTime && istoTime) time = `To ${formatTime(istoTime)}`;

    return `${isSameTime ? formatDate(state.startTime) : time}`;
  }

  renderCollapsePrice= () => {
    const state = this.state;
    if (!state.minPrice) { return '<= ' + state.maxPrice; }
    if (!state.maxPrice) { return '>= ' + state.minPrice; }
    const isSamePrice = state.maxPrice === state.minPrice;

    return `${isSamePrice ? state.minPrice : state.minPrice + '-' + state.maxPrice}`;
  }

  renderCollapseSide () {
    const sidesSelected = sideTypes.filter(item => this.state.side.includes(item.id));
    const sideString = sidesSelected.map(e => e.value).join(',');
    return sideString;
  }

  renderCollapseCategory () {
    const categorySelected = idqsCategoryTypes.filter(item => this.state.category.includes(item.id));
    const categoryString = categorySelected.map(e => e.value).join(',');
    return categoryString;
  }

  renderCollapseStatusType () {
    const orderStatusTypesSelected = orderStatusTypes.filter(item => this.state.orderStatus.includes(item.id));
    const orderStatusTypesString = orderStatusTypesSelected.map(e => e.value).join(',');
    return orderStatusTypesString;
  }

  renderCollapseSize= () => {
    const state = this.state;
    if (!state.minSize) { return '<= ' + state.maxSize; }
    if (!state.maxSize) { return '>= ' + state.minSize; }
    const isSameSize = state.maxSize === state.minSize;

    return `${isSameSize ? state.minSize : state.minSize + '-' + state.maxSize}`;
  }

  handleKeyDown (e) {
    if (e.key === 'Enter') {
      this.setState({
        isSymbolFocus: false,
        isMpidFocus: false
      });

      this.handleSubmit('search');
    };
  }

  render () {
    const { recentSymbolSearch, recentMpidSearch } = this.state;
    const isSymbolFocus = this.state.isSymbolFocus && recentSymbolSearch;
    const isMpidFocus = this.state.isMpidFocus && recentMpidSearch;
    const isFilterOpen = this.state.showFilter;
    return (
      <div id='idqsOrderFilter' className={styles.container}>
        <div className={styles.formContainer}>
          {isFilterOpen && <div className={styles.orderGridStyle} onKeyDown={this.handleKeyDown}>

            <div key={'symbolKey'}>
              <Label title='Symbol' />
              <TextBox
                name={'symbol'} placeholder={'Symbol'} value={this.state['symbol']} showClearButton
                valueChangeEvent='keyup'
                onFocusIn={() => this.handleFocusIn('isSymbolFocus')}
                onFocusOut={() => this.handleFocusOut('isSymbolFocus')}
                onValueChanged={(e) => this.handleChange(e, 'symbol')} />
              {isSymbolFocus && recentSymbolSearch.length > 0 && <div className={styles.listContainer}>
                <i className={styles.note}>Recent searches:</i>
                <List
                  dataSource={recentSymbolSearch}
                  height='100%'
                  onItemClick={(e) => this.handleListItemClick(e, 'symbol')} />
              </div>}

            </div>

            <div key={'startDateKey'}>
              <Label title='Start Date' />
              <DateBox
                name={'startDate'}
                value={this.state['startDate']}
                placeholder={'MM/DD/YYYY'}
                useMaskBehavior
                openOnFieldClick
                max={new Date()}
                onValueChanged={(e) => this.handleChange(e, 'startDate')}
                displayFormat={filterDatePattern} /></div>

            <div key={'endDateKey'}>
              <div
                id='end-date-label'
                onMouseEnter={() => this.showToolTip('toDateToolTip')}
                onMouseLeave={() => this.hideToolTip('toDateToolTip')}
                onClick={() => this.handleCopyValue('endDate', 'startDate')}>
                <Label className={styles.labelButton} title='End Date' />

                <Tooltip
                  target='#end-date-label'
                  position='top'
                  visible={this.state.toDateToolTip}
                  hideOnOutsideClick={false}>
                    Copy Start Date
                </Tooltip>
              </div>

              <DateBox
                name={'endDate'}
                value={this.state['endDate']}
                placeholder={'MM/DD/YYYY'}
                useMaskBehavior
                openOnFieldClick
                max={new Date()}
                onValueChanged={(e) => this.handleChange(e, 'endDate')}
                displayFormat={filterDatePattern} /></div>

            <div key={'startTimeKey'}>
              <Label title='Updated Start Time' />
              <DateBox
                type='time'
                name={'startTime'}
                value={this.state['startTime']}
                placeholder={'HH:mm:ss.SSS'}
                showClearButton
                useMaskBehavior
                showDropDownButton={false}
                onValueChanged={(e) => this.handleChange(e, 'startTime')}
                displayFormat={filterTimePattern} /></div>

            <div key={'endTimeKey'}>
              <div
                id='end-time-label'
                onMouseEnter={() => this.showToolTip('toTimeToolTip')}
                onMouseLeave={() => this.hideToolTip('toTimeToolTip')}
                onClick={() => this.handleCopyValue('endTime', 'startTime')}>
                <Label className={styles.labelButton} title='Updated End Time' />
                <Tooltip
                  target='#end-time-label'
                  position='top'
                  visible={this.state.toTimeToolTip}
                  hideOnOutsideClick={false}>
                  Copy Updated Start Time
                </Tooltip>
              </div>

              <DateBox
                type='time'
                name={'endTime'}
                value={this.state['endTime']}
                placeholder={'HH:mm:ss.SSS'}
                showClearButton
                useMaskBehavior
                showDropDownButton={false}
                onValueChanged={(e) => this.handleChange(e, 'endTime')}
                displayFormat={filterTimePattern} /></div>

            <div key={'orderEnterStartTimeKey'}>
              <Label title='Entered Start Time' />
              <DateBox
                type='time'
                name={'orderEnterStartTime'}
                value={this.state['orderEnterStartTime']}
                placeholder={'HH:mm:ss.SSS'}
                showClearButton
                useMaskBehavior
                showDropDownButton={false}
                onValueChanged={(e) => this.handleChange(e, 'orderEnterStartTime')}
                displayFormat={filterTimePattern} /></div>

            <div key={'orderEnterEndTimeKey'}>
              <div
                id='entered-end-time-label'
                onMouseEnter={() => this.showToolTip('toEnteredTimeToolTip')}
                onMouseLeave={() => this.hideToolTip('toEnteredTimeToolTip')}
                onClick={() => this.handleCopyValue('orderEnterEndTime', 'orderEnterStartTime')}>
                <Label className={styles.labelButton} title='Entered End Time' />
                <Tooltip
                  target='#entered-end-time-label'
                  position='top'
                  visible={this.state.toEnteredTimeToolTip}
                  hideOnOutsideClick={false}>
                  Copy Entered Start Time
                </Tooltip>
              </div>

              <DateBox
                type='time'
                name={'orderEnterEndTime'}
                value={this.state['orderEnterEndTime']}
                placeholder={'HH:mm:ss.SSS'}
                showClearButton
                useMaskBehavior
                showDropDownButton={false}
                onValueChanged={(e) => this.handleChange(e, 'orderEnterEndTime')}
                displayFormat={filterTimePattern} /></div>

            <div key={'mpidKey'}>
              <Label title='MPID' />
              <TextBox
                name={'mpid'} placeholder={'MPID'} value={this.state['mpid']} showClearButton
                valueChangeEvent='keyup'
                onFocusIn={() => this.handleFocusIn('isMpidFocus')}
                onFocusOut={() => this.handleFocusOut('isMpidFocus')}
                onValueChanged={(e) => this.handleChange(e, 'mpid')} />
              {isMpidFocus && recentMpidSearch.length > 0 && <div className={styles.listContainer}>
                <i className={styles.note}>Recent searches:</i>
                <List
                  dataSource={recentMpidSearch}
                  height='100%'
                  onItemClick={(e) => this.handleListItemClick(e, 'mpid')} />
              </div>}

            </div>

            <div key={'sideKey'}>
              <Label title='Side' />
              <TagBox id={'side'}
                dataSource={sideTypes}
                showClearButton
                placeholder={'Side'}
                value={this.state['side']}
                displayExpr='value'
                valueExpr='id'
                name={'side'}
                multiline={false}
                showDropDownButton
                showSelectionControls
                wrapItemText
                maxDisplayedTags={2}
                showMultiTagOnly
                inputAttr={disableAutoComplete}
                onValueChanged={(e) => this.handleChange(e, 'side')} /></div>

            <div key={'linkAtsIdKey'}>
              <Label title='Link ATS ID' />
              <TextBox
                name={'linkAtsId'} placeholder={'Link ATS ID'} value={this.state['linkAtsId']} showClearButton
                valueChangeEvent='keyup'
                onValueChanged={(e) => this.handleChange(e, 'linkAtsId')} /></div>

            <div key={'orderCapacityKey'}>
              <Label title='Order Capacity' />
              <SelectBox id={'orderCapacity'}
                dataSource={capacityTypes}
                showClearButton
                placeholder={'Order Capacity'}
                value={this.state['orderCapacity']}
                displayExpr='value'
                valueExpr='id'
                name={'orderCapacity'}
                searchEnabled
                inputAttr={disableAutoComplete}
                onValueChanged={(e) => this.handleChange(e, 'orderCapacity')} /></div>

            <div key={'clientOrderIdKey'}>
              <Label title='Client Order ID' />
              <TextBox
                name={'clientOrderId'} placeholder={'Client Order ID'} value={this.state['clientOrderId']} showClearButton
                valueChangeEvent='keyup'
                onValueChanged={(e) => this.handleChange(e, 'clientOrderId')} /></div>

            <div key={'orderStatusKey'}>
              <Label title='Order Status' />
              <TagBox id={'orderStatus'}
                dataSource={orderStatusTypes}
                showClearButton
                placeholder={'Order Status'}
                value={this.state['orderStatus']}
                displayExpr='value'
                valueExpr='id'
                name={'orderStatus'}
                showDropDownButton
                showSelectionControls
                wrapItemText
                maxDisplayedTags={2}
                showMultiTagOnly
                inputAttr={disableAutoComplete}
                onValueChanged={(e) => this.handleChange(e, 'orderStatus')} /></div>

            <div key={'orderIdKey'}>
              <Label title='Order ID' />
              <TextBox
                name={'orderId'} placeholder={'Order ID'} value={this.state['orderId']} showClearButton
                valueChangeEvent='keyup'
                onValueChanged={(e) => this.handleChange(e, 'orderId')} /></div>

            <div key={'categoryKey'}>
              <Label title='Destination' />
              <TagBox id={'category'}
                dataSource={idqsCategoryTypes}
                showClearButton
                placeholder={'Destination'}
                value={this.state['category']}
                displayExpr='value'
                valueExpr='id'
                name={'category'}
                multiline={false}
                showDropDownButton
                showSelectionControls
                wrapItemText
                maxDisplayedTags={2}
                showMultiTagOnly
                inputAttr={disableAutoComplete}
                onValueChanged={(e) => this.handleChange(e, 'category')} /></div>

            <div key={'minPriceKey'}>
              <Label title='Min Order Price' />
              <NumberBox mode='number'
                name={'minPrice'} placeholder={'Min Order Price'} value={this.state['minPrice']} showClearButton
                valueChangeEvent='keyup' min={0}
                onValueChanged={(e) => this.handleChange(e, 'minPrice')} /></div>

            <div key={'maxPriceKey'}>
              <Label title='Max Order Price' />
              <NumberBox mode='number'
                name={'maxPrice'} placeholder={'Max Order Price'} value={this.state['maxPrice']} showClearButton
                valueChangeEvent='keyup' min={0}
                onValueChanged={(e) => this.handleChange(e, 'maxPrice')} /></div>

            <div key={'minSizeKey'}>
              <Label title='Min Order Size' />
              <NumberBox mode='number'
                name={'minSize'} placeholder={'Min Order Size'} value={this.state['minSize']} showClearButton
                valueChangeEvent='keyup' min={0}
                format={'###0'}
                onValueChanged={(e) => this.handleChange(e, 'minSize')} /></div>

            <div key={'maxSizeKey'}>
              <Label title='Max Order Size' />
              <NumberBox mode='number'
                name={'maxSize'} placeholder={'Max Order Size'} value={this.state['maxSize']} showClearButton
                valueChangeEvent='keyup' min={0}
                format={'###0'}
                onValueChanged={(e) => this.handleChange(e, 'maxSize')} /></div>
          </div>}
          {!isFilterOpen && <div className={styles.collapsedContainer}>

            {this.state.symbol && <span className={styles.field}>
              <Label title='Symbol: ' isInline /> {this.state.symbol}
            </span>}
            <span className={styles.field}>
              <Label title='Date: ' isInline /> {this.renderCollapseDate()}
            </span>
            {(this.state.startTime || this.state.endTime) && <span className={styles.field}>
              <Label title='Updated Time: ' isInline /> {this.renderUpdateTime()}
            </span>}
            {(this.state.orderEnterStartTime || this.state.orderEnterEndTime) && <span className={styles.field}>
              <Label title='Entered Time: ' isInline /> {this.renderEnteredTime()}
            </span>}
            {this.state.mpid && <span className={styles.field}>
              <Label title='MPID: ' isInline /> {this.state.mpid}
            </span>}
            {this.state.side && this.state.side.length > 0 && <span className={styles.field}>
              <Label title='Side: ' isInline /> {this.renderCollapseSide()}
            </span>}
            {this.state.linkAtsId && <span className={styles.field}>
              <Label title='Link ATS ID: ' isInline /> {this.state.linkAtsId}
            </span>}
            {this.state.orderCapacity && <span className={styles.field}>
              <Label title='Order Capacity: ' isInline /> {this.state.orderCapacity}
            </span>}
            {this.state.clientOrderId && <span className={styles.field}>
              <Label title='Client Order ID: ' isInline /> {this.state.clientOrderId}
            </span>}
            {this.state.orderStatus && this.state.orderStatus.length > 0 && <span className={styles.field}>
              <Label title='Order Status: ' isInline /> {this.renderCollapseStatusType()}
            </span>}
            {this.state.orderId && <span className={styles.field}>
              <Label title='Order ID: ' isInline /> {this.state.orderId}
            </span>}
            {this.state.category && this.state.category.length > 0 && <span className={styles.field}>
              <Label title='Destination: ' isInline /> {this.renderCollapseCategory()}
            </span>}
            {(this.state.minPrice || this.state.maxPrice) && <span className={styles.field}>
              <Label title='Order Price: ' isInline /> {this.renderCollapsePrice()}
            </span> }
            {(this.state.minSize || this.state.maxSize) && <span className={styles.field}>
              <Label title='Order Size: ' isInline /> {this.renderCollapseSize()}
            </span>}
          </div>}

          <div className={styles.controls}>
            {isFilterOpen && <Button title='Search' onClick={this.handleSearch} size='extraSmall' /> }
            <Button title='Excel' size='extraSmall' inactive={this.props.isDownloadInactive} onClick={this.handleDownload} />
            {this.props.isDownloadInactive && <span> Downloading...</span>}
            {isFilterOpen && <div className={styles.collapseOption}>
              <CheckBox
                width='100%'
                text='Collapse filters upon search results'
                onValueChanged={this.handleCollapseOption}
                value={this.state.collapseOnSearch}
              />
            </div> }
          </div>
          <div className={styles.errorMessages}>
            {this.state.errorMessages.length > 0 && this.renderErrorMessages()}
          </div>
          <div className={styles.toggle} onClick={this.toggleFilter}>
            {this.state.showFilter && <FaAngleDoubleUp />}
            {!this.state.showFilter && <FaAngleDoubleDown />}
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(IdqsOrderFilter);

IdqsOrderFilter.propTypes = {
  search: PropTypes.func,
  startDateUpdate: PropTypes.string,
  endDateUpdate: PropTypes.string,
  mpidUpdate: PropTypes.string,
  symbolUpdate: PropTypes.string,
  orderIdUpdate: PropTypes.string,
  clientOrderIdUpdate: PropTypes.string,
  minPriceUpdate: PropTypes.string,
  maxPriceUpdate: PropTypes.string,
  startTimeUpdate: PropTypes.string,
  endTimeUpdate: PropTypes.string,
  isDownloadInactive: PropTypes.bool,
  isDataLoaded: PropTypes.bool

};
